/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Ai_Notice_Toggle_HelpInputs */

const en_candidate_ai_notice_toggle_help = /** @type {(inputs: Candidate_Ai_Notice_Toggle_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advisory only — this does not delete AI outputs; you review everything before use.`)
};

const de_candidate_ai_notice_toggle_help = /** @type {(inputs: Candidate_Ai_Notice_Toggle_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur beratend — dadurch werden keine KI-Ausgaben gelöscht; Sie prüfen alles vor der Verwendung.`)
};

const fr_candidate_ai_notice_toggle_help = /** @type {(inputs: Candidate_Ai_Notice_Toggle_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À titre consultatif uniquement — cela ne supprime pas les résultats de l’IA ; vous examinez tout avant utilisation.`)
};

const es_candidate_ai_notice_toggle_help = /** @type {(inputs: Candidate_Ai_Notice_Toggle_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo orientativo — esto no elimina los resultados de IA; revisas todo antes de usarlo.`)
};

const it_candidate_ai_notice_toggle_help = /** @type {(inputs: Candidate_Ai_Notice_Toggle_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo a titolo consultivo — ciò non elimina i risultati dell’IA; esamini tutto prima dell’uso.`)
};

const nl_candidate_ai_notice_toggle_help = /** @type {(inputs: Candidate_Ai_Notice_Toggle_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alleen adviserend — dit verwijdert geen AI-resultaten; je beoordeelt alles vóór gebruik.`)
};

const pl_candidate_ai_notice_toggle_help = /** @type {(inputs: Candidate_Ai_Notice_Toggle_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyłącznie doradczo — nie powoduje to usunięcia wyników AI; przeglądasz wszystko przed użyciem.`)
};

const fi_candidate_ai_notice_toggle_help = /** @type {(inputs: Candidate_Ai_Notice_Toggle_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vain neuvoa-antava — tämä ei poista tekoälyn tuloksia; tarkistat kaiken ennen käyttöä.`)
};

const da_candidate_ai_notice_toggle_help = /** @type {(inputs: Candidate_Ai_Notice_Toggle_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kun vejledende — dette sletter ikke AI-resultater; du gennemgår alt før brug.`)
};

const sv_candidate_ai_notice_toggle_help = /** @type {(inputs: Candidate_Ai_Notice_Toggle_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endast vägledande — detta tar inte bort AI-resultat; du granskar allt före användning.`)
};

/**
* | output |
* | --- |
* | "Advisory only — this does not delete AI outputs; you review everything before use." |
*
* @param {Candidate_Ai_Notice_Toggle_HelpInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const candidate_ai_notice_toggle_help = /** @type {((inputs?: Candidate_Ai_Notice_Toggle_HelpInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Ai_Notice_Toggle_HelpInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_ai_notice_toggle_help(inputs)
	if (locale === "fr") return fr_candidate_ai_notice_toggle_help(inputs)
	if (locale === "es") return es_candidate_ai_notice_toggle_help(inputs)
	if (locale === "it") return it_candidate_ai_notice_toggle_help(inputs)
	if (locale === "nl") return nl_candidate_ai_notice_toggle_help(inputs)
	if (locale === "pl") return pl_candidate_ai_notice_toggle_help(inputs)
	if (locale === "fi") return fi_candidate_ai_notice_toggle_help(inputs)
	if (locale === "da") return da_candidate_ai_notice_toggle_help(inputs)
	if (locale === "sv") return sv_candidate_ai_notice_toggle_help(inputs)
	return en_candidate_ai_notice_toggle_help(inputs)
});